import { useAuth } from '../../contexts/AuthContext'
import { Link } from 'react-router-dom'
import ChecklistReview from './ChecklistReview'

const ChecklistPage = () => {
  const { user } = useAuth()
  const isHeadOfAcquisition = user?.role?.level === 3
  const isCOO = user?.role?.level === 2

  console.log('🔍 ChecklistPage rendered:', {
    user: user ? { id: user.id, role: user.role.name, level: user.role.level } : null,
    isHeadOfAcquisition,
    isCOO
  })

  if (isHeadOfAcquisition || isCOO) {
    console.log('🔄 Rendering ChecklistReview component')
    return <ChecklistReview />
  }

  console.log('🔄 Rendering default ChecklistPage content')
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Checklists</h1>
        <p className="mt-1 text-sm text-gray-600">
          Manage checklist items and requirements
        </p>
      </div>

      <div className="card">
        <div className="card-body">
          <h2 className="text-lg font-semibold text-gray-900 mb-4">
            Task Management Center
          </h2>
          <p className="text-gray-600">
            This page provides comprehensive task management for all checklist items with media upload requirements and GPS validation.
          </p>
          <div className="mt-4 flex space-x-4">
            <Link
              to="/checklists/review"
              className="btn-primary"
            >
              Review Tasks
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ChecklistPage 